import { github } from '@code-surfer/themes';
/*
export default {
  styles: {
    CodeSurfer: {
      title: {
		font: '"Verlag Cond A", "Verlag Cond B"',
		fontWeight: 700,
      },
      subtitle: {
        color: "#d6deeb",
        backgroundColor: "rgba(10,10,10,0.9)"
      },
      unfocused: {
        // only the opacity of unfocused code can be changed
        opacity: 0.1
      }
    }
  }
};
*/

github.fonts = {
	body: '"Verlag Cond A", "Verlag Cond B"',
	heading: '"Verlag Cond A", "Verlag Cond B"',
};
github.fontWeights = { body: 300, heading: 300, bold: 700 };
github.colors = {
	background: '#eee',
	text: '#900',
	primary: '#900',
};
github.googleFont = 'https://cloud.typography.com/7598912/612904/css/fonts.css';
github.styles.CodeSurfer.subtitle.backgroundColor = '#900';

export default github;
